export default __webpack_public_path__ + "static/media/IMG_4737.786ac759.JPG";